import React from 'react';

interface HeatproofMatProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
  /** Side length in metres. Default 0.55. */
  size?: number;
}

/**
 * Heatproof mat — a thick black ceramic-fibre pad placed under heated
 * apparatus to protect the workbench. Used here under the tripod stand
 * during the magnesium combustion experiment.
 */
export function HeatproofMat({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  size = 0.55,
}: HeatproofMatProps) {
  const thickness = 0.014;
  return (
    <group position={position} rotation={rotation} scale={scale}>
      {/* Main mat body */}
      <mesh position={[0, thickness / 2, 0]} receiveShadow castShadow>
        <boxGeometry args={[size, thickness, size]} />
        <meshStandardMaterial color="#1c1c1f" roughness={0.92} metalness={0.05} />
      </mesh>
      {/* Subtle bevelled edge */}
      <mesh position={[0, thickness - 0.0005, 0]}>
        <boxGeometry args={[size * 0.97, 0.0015, size * 0.97]} />
        <meshStandardMaterial color="#2a2a2e" roughness={0.85} metalness={0.04} />
      </mesh>
      {/* Faint manufacturer logo plate */}
      <mesh position={[size * 0.32, thickness + 0.001, size * 0.36]}>
        <boxGeometry args={[0.04, 0.0008, 0.012]} />
        <meshStandardMaterial color="#666" roughness={0.7} metalness={0.5} />
      </mesh>
    </group>
  );
}

export default HeatproofMat;
